<template>
<div>
     <v-app>
        <v-toolbar
        color="blue lighten-2" dark>
        <v-app-bar-nav-icon @click.stop="sideNav= !sideNav" class="hidden-sm-and-up"></v-app-bar-nav-icon>
        <v-toolbar-title>Projects</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
            
        </v-btn>
        <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </v-toolbar>
        <v-toolbar
          
        >
          <v-app-bar-nav-icon  class="hidden-sm-and-up"></v-app-bar-nav-icon>
             <v-row>
                <v-col
                cols="12"
               
                md="6"
              >
                <v-text-field
                  style="margin-top:30px"
                  label="Search"
                  solo
                ></v-text-field>
              </v-col>
             </v-row> 

          <v-spacer></v-spacer>
         
          <v-btn icon>
            <v-icon></v-icon>
          </v-btn>
        </v-toolbar>                 
   
     <v-navigation-drawer  v-model="sideNav" app color="grey lighten-5"
              absolute
              temporary
              width="200"
      >          
                <v-list>
                  <v-list-item>
                    <v-list-item-avatar>
                       <v-avatar style="background: grey"
                            color="brown"
                            size="50"
                            class="ml-2"
                            >
                            <span class="white--text text-h5"></span>
                            </v-avatar>
                    </v-list-item-avatar>
                  </v-list-item>
                  <v-list-item link>
                    <v-list-item-content>
                      <v-list-item-title class="text-h6">
                       User Name
                      </v-list-item-title>
                      <v-list-item-subtitle> name@mail.com</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon>mdi-menu-down</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list>
                   <v-list-item v-for="item in menuItems" :key="item.title" link :to="item.link">  
                      <v-list-item-icon>
                          <v-icon v-text="item.icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content class="ml-1">
                          <v-list-item-title>{{item.title}}</v-list-item-title>
                      </v-list-item-content>
                   </v-list-item>
                </v-list>
        </v-navigation-drawer>
   <router-view></router-view>
</v-app>
</div>

</template>
<script>
    export default {
        name:"App",
        data(){
            return {
                sideNav: false,
                menuItems: [
                    {icon:  'mdi-home', title: 'Menu Item 1', link: '/'},
                    {icon:  'mdi-view-dashboard', title: 'Menu Item 2', link: '/'},
                     {icon:  'mdi-progress-check', title: 'Menu Item 3', link: '/'},
                    {icon:  'mdi-delete', title: 'Menu Item 4', link: '/'},
                    {icon:  'mdi-tea', title: 'Menu Item 5', link: '/'},
                    {icon:  'mdi-human-greeting', title: 'Menu Item 6', link: '/'},
                    
                ]
            }
        },
        mounted() {
            console.log('App Component mounted.')
        },
      
    }
</script>


